export default function AboutSection() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-sm text-orange-600 font-semibold mb-2">• Sobre Nós</p>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">Mundo Crocs Moçambique</h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Somos uma loja moçambicana especializada em <strong>Crocs personalizados</strong> com pins decorativos únicos. Cada par é cuidadosamente preparado para oferecer não apenas conforto excepcional, mas também um estilo divertido e exclusivo.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Nossos Crocs vêm decorados com <strong>pins variados</strong> incluindo personagens, símbolos, ícones e temas divertidos que transformam cada calçado numa peça única de expressão pessoal.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Oferecemos <strong>10 cores vibrantes</strong> para você escolher, todas ao mesmo preço acessível de <strong>1.800 MZN</strong>. Qualidade, conforto e estilo garantidos!
            </p>
            
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="text-center p-6 bg-orange-50 rounded-2xl">
                <div className="w-16 h-16 flex items-center justify-center bg-orange-500 rounded-full mx-auto mb-3">
                  <i className="ri-palette-line text-3xl text-white"></i>
                </div>
                <p className="text-3xl font-bold text-gray-900 mb-1">10</p>
                <p className="text-sm text-gray-600">Cores Disponíveis</p>
              </div>
              
              <div className="text-center p-6 bg-pink-50 rounded-2xl">
                <div className="w-16 h-16 flex items-center justify-center bg-pink-500 rounded-full mx-auto mb-3">
                  <i className="ri-star-line text-3xl text-white"></i>
                </div>
                <p className="text-3xl font-bold text-gray-900 mb-1">100%</p>
                <p className="text-sm text-gray-600">Personalizados</p>
              </div>
            </div>

            <button
              onClick={() => window.open('https://wa.me/258869689262?text=Olá! Gostaria de saber mais sobre os Crocs personalizados.', '_blank')}
              className="inline-flex items-center gap-3 px-8 py-4 bg-green-500 text-white text-lg font-semibold rounded-full hover:bg-green-600 hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-whatsapp-line text-xl"></i>
              </div>
              Fale Conosco
            </button>
          </div>

          <div className="relative">
            <div className="w-full h-full aspect-square rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/e1d4d4b584bd97cf3a3e5a01190844bc.jpg"
                alt="Coleção de Crocs Personalizados"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-yellow-400 text-gray-900 px-8 py-6 rounded-2xl shadow-xl">
              <p className="text-sm font-semibold mb-1">Preço Fixo</p>
              <p className="text-4xl font-bold">1.800 MZN</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
